var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavouriteStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-path": "fill",
    y: 0.320801,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#5555A0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9778 5.11399C7.41097 4.03409 7.62756 3.49414 8 3.49414C8.37244 3.49414 8.58903 4.03409 9.0222 5.11399L9.04238 5.16427C9.2871 5.77436 9.40946 6.07941 9.65884 6.26482C9.90821 6.45023 10.2356 6.47955 10.8903 6.53818L11.0087 6.54878C12.0802 6.64475 12.616 6.69273 12.7306 7.03359C12.8452 7.37446 12.4474 7.73645 11.6516 8.46043L11.386 8.70206C10.9832 9.06855 10.7818 9.2518 10.6879 9.49197C10.6704 9.53677 10.6558 9.58267 10.6443 9.62938C10.5826 9.87975 10.6416 10.1456 10.7595 10.6773L10.7963 10.8428C11.013 11.8199 11.1214 12.3084 10.9322 12.5191C10.8615 12.5979 10.7695 12.6546 10.6674 12.6824C10.3942 12.757 10.0062 12.4409 9.23035 11.8086C8.72087 11.3935 8.46613 11.1859 8.17366 11.1392C8.05861 11.1208 7.94139 11.1208 7.82634 11.1392C7.53387 11.1859 7.27913 11.3935 6.76965 11.8086C5.99376 12.4409 5.60581 12.757 5.33256 12.6824C5.23045 12.6546 5.13854 12.5979 5.06782 12.5191C4.87856 12.3084 4.98695 11.8199 5.20374 10.8427L5.24046 10.6773C5.35842 10.1456 5.41741 9.87975 5.3557 9.62938C5.34419 9.58267 5.32963 9.53677 5.31212 9.49197C5.21824 9.2518 5.01682 9.06855 4.61399 8.70206L4.34841 8.46043C3.55264 7.73645 3.15475 7.37446 3.2694 7.03359C3.38404 6.69273 3.9198 6.64475 4.99134 6.54878L5.1097 6.53818C5.76442 6.47955 6.09178 6.45023 6.34116 6.26482C6.59054 6.07941 6.7129 5.77436 6.95762 5.16427L6.9778 5.11399Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteStar);
export default __webpack_public_path__ + "static/media/favourite_star.9fd5d36e03cc9570794224251302d8dc.svg";
export { ForwardRef as ReactComponent };